/**
 * Prix catalogue = TTC (affichés au client final).
 * La TVA sert à la décomposition comptable (HT + TVA), pas à majorer le prix.
 */

export const roundMoney = (value) => Number(Number(value).toFixed(2));

export const splitTtcToHtTva = (prixTTC, tauxTVA = 20) => {
  const ttc = roundMoney(Math.max(0, Number(prixTTC) || 0));
  const rate = Number(tauxTVA);
  if (!Number.isFinite(rate) || rate <= 0) {
    return { ttc, ht: ttc, tva: 0, tauxTVA: rate || 0 };
  }
  const ht = roundMoney(ttc / (1 + rate / 100));
  const tva = roundMoney(ttc - ht);
  return { ttc, ht, tva, tauxTVA: rate };
};

/**
 * Récap tarifaire rendez-vous pour l'admin (prix TTC + détail TVA)
 */
export const buildRdvPricingRecap = (commande) => {
  const participants = Math.max(1, Number(commande?.participants ?? 1));
  const defaultTvaRate = Number(commande?.prestation?.tauxTVA ?? 20);
  const unitTTC = Number(commande?.prestation?.prix ?? 0);
  const prestationTTC = roundMoney(unitTTC * participants);
  const prestation = splitTtcToHtTva(prestationTTC, defaultTvaRate);

  const optionsSelection = Array.isArray(commande?.optionsSelection)
    ? commande.optionsSelection
    : [];

  const optionsDetails = optionsSelection.map((opt) => {
    const quantite = Number(opt.quantite ?? 1);
    const lineTTC = roundMoney(Number(opt.prixSupplement ?? 0) * quantite);
    const tauxTVA = Number(opt.tauxTVA ?? defaultTvaRate);
    const split = splitTtcToHtTva(lineTTC, tauxTVA);
    return {
      ...opt,
      quantite,
      prixUnitaireTTC: Number(opt.prixSupplement ?? 0),
      tauxTVA,
      ...split,
    };
  });

  const optionsTotals = optionsDetails.reduce(
    (acc, o) => ({
      ttc: roundMoney(acc.ttc + o.ttc),
      ht: roundMoney(acc.ht + o.ht),
      tva: roundMoney(acc.tva + o.tva),
    }),
    { ttc: 0, ht: 0, tva: 0 },
  );

  const totalTTC = Number(commande?.totalTTC ?? roundMoney(prestation.ttc + optionsTotals.ttc));
  const totalHT = Number(commande?.totalHT ?? roundMoney(prestation.ht + optionsTotals.ht));
  const totalTVA = Number(commande?.totalTVA ?? roundMoney(prestation.tva + optionsTotals.tva));
  const promoReduction = Math.max(0, Number(commande?.reduction ?? 0));
  const montantAPayer = Number(
    commande?.prixFinal ?? commande?.total ?? roundMoney(totalTTC - promoReduction),
  );

  return {
    participants,
    defaultTvaRate,
    unitTTC,
    prestation,
    optionsDetails,
    totalHT,
    totalTVA,
    totalTTC,
    montantAPayer,
    promoReduction,
  };
};
